<template>
  <div>
    <!--기본정보-->
    <field-select-module
      :fieldName="fieldName"
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--협의체 정보-->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 위원회 정보</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
<!--        <div class="col-span-4 flex items-center">-->
<!--          <div class="label-text">구분</div>-->
<!--          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_1 }}</p>-->
<!--          <vs-select-->
<!--            v-model="form.inputA_1"-->
<!--            autocomplete-->
<!--            v-else-->
<!--            :readonly="board.readonly"-->
<!--            class="w-full flex-1"-->
<!--          >-->
<!--            <vs-select-item text="최초" value="최초" />-->
<!--            <vs-select-item text="정기" value="정기" />-->
<!--            <vs-select-item text="수시" value="수시" />-->
<!--          </vs-select>-->
<!--        </div>-->
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">회의일</div>
          <p v-if="isPrint" class="w-full flex-1">
            {{ form.inputA_2 }}
          </p>
          <div v-else class="flex-1 flex items-center">
            <date-selector
              class="w-full"
              v-model="form.inputA_2"
              :readonly="board.readonly"
            />
          </div>
        </div>
<!--        <div class="col-span-4 flex items-center">-->
<!--          <div class="label-text mr-4">차수</div>-->
<!--          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_3 }}</p>-->
<!--          <ml-input-->
<!--            :readonly="board.readonly"-->
<!--            v-else-->
<!--            v-model="form.inputA_3"-->
<!--            class="w-full flex-1"-->
<!--          />-->
<!--        </div>-->
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">노측 위원(명)</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_4 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            type="number"
            v-model="form.inputA_4"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">사측 위원(명)</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_5 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            type="number"
            v-model="form.inputA_5"
            class="w-full flex-1"
          />
        </div>
      </div>
    </div>

    <!-- 위험성평가협의회(사용자) -->
    <div class="mt-5">
      <vs-row class="flex justify-between items-center my-4">
        <h5><i class="dot"></i> 산업안전보건위원회(사용자)</h5>
        <div>
          <vs-button
            class="ml-4"
            color="secondary"
            @click="addTableRow('userTableList')"
          >
            항목추가
          </vs-button>
          <vs-button
            class="ml-4"
            color="secondary"
            type="border"
            @click="deleteSelectTable('userTableList')"
          >
            선택삭제
          </vs-button>
        </div>
      </vs-row>
      <vs-table
        multiple
        v-model="userSelected"
        :data="form.userTableList"
        class="w-full table"
        noDataText="데이터가 없습니다"
      >
        <template slot="thead">
          <vs-th> <div class="w-full text-center">소속명</div> </vs-th>
          <vs-th> <div class="w-full text-center">직책</div></vs-th>
          <vs-th> <div class="w-full text-center">이름</div></vs-th>
          <vs-th> <div class="w-full text-center">서명</div> </vs-th>
          <vs-th> <div class="w-full text-center">비고</div></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
            style="box-shadow: none !important; transform: translateY(0px)"
          >
            <vs-td class="w-2/12 text-center align-top">
              <div v-if="isPrint" class="print-input"> {{ tr.cell1 }}</div>
              <ml-input v-else
                :readonly="board.readonly"
                v-model="tr.cell1"
                class="w-full flex-1"
                @click.stop
              />
            </vs-td>
            <vs-td class="w-2/12 text-center align-top">
              <div v-if="isPrint" class="print-input"> {{ tr.cell2 }}</div>
              <vs-select v-else
                v-model="tr.cell2"
                autocomplete
                :readonly="board.readonly"
                class="w-full flex-1"
              >
                <vs-select-item text="사용자대표" value="사용자대표" />
                <vs-select-item text="안전관리자" value="안전관리자" />
                <vs-select-item text="보건관리자" value="보건관리자" />
                <vs-select-item text="관리감독자" value="관리감독자" />
                <vs-select-item text="사용자위원" value="사용자위원" />
                <vs-select-item text="기타" value="기타" />
              </vs-select>
            </vs-td>
            <vs-td class="w-2/12 text-center align-top">
              <div v-if="isPrint" class="print-input"> {{ tr.cell3 }}</div>
              <ml-input v-else
                :readonly="board.readonly"
                v-model="tr.cell3"
                class="w-full flex-1"
                @click.stop
              />
            </vs-td>
            <vs-td class="w-2/12 text-center align-top">
              <sign-field v-model="tr.cell4" :readonly="board.readonly"/>
            </vs-td>
            <vs-td class="w-2/12 text-center align-top">
              <div v-if="isPrint" class="print-input"> {{ tr.cell5 }}</div>
              <ml-input v-else
                :readonly="board.readonly"
                v-model="tr.cell5"
                class="w-full flex-1"
                @click.stop
              />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <!-- 위험성평가협의회(근로자) -->
    <div class="mt-5">
      <vs-row class="flex justify-between items-center my-4">
        <h5><i class="dot"></i> 산업안전보건위원회(근로자)</h5>
        <div>
          <vs-button
            class="ml-4"
            color="secondary"
            @click="addTableRow('workerTableList')"
          >
            항목추가
          </vs-button>
          <vs-button
            class="ml-4"
            color="secondary"
            type="border"
            @click="deleteSelectTable('workerTableList')"
          >
            선택삭제
          </vs-button>
        </div>
      </vs-row>
      <vs-table
        multiple
        v-model="workerSelected"
        :data="form.workerTableList"
        class="w-full table"
        noDataText="데이터가 없습니다"
      >
        <template slot="thead">
          <vs-th> <div class="w-full text-center">소속명</div> </vs-th>
          <vs-th> <div class="w-full text-center">직책</div></vs-th>
          <vs-th> <div class="w-full text-center">이름</div></vs-th>
          <vs-th> <div class="w-full text-center">서명</div> </vs-th>
          <vs-th> <div class="w-full text-center">비고</div></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
            style="box-shadow: none !important; transform: translateY(0px)"
          >
            <vs-td class="w-2/12 text-center align-top">
              <div v-if="isPrint" class="print-input"> {{ tr.cell1 }}</div>
              <ml-input v-else
                :readonly="board.readonly"
                v-model="tr.cell1"
                class="w-full flex-1"
                @click.stop
              />
            </vs-td>
            <vs-td class="w-2/12 text-center align-top">
              <div v-if="isPrint" class="print-input"> {{ tr.cell2 }}</div>
              <vs-select v-else
                v-model="tr.cell2"
                autocomplete
                :readonly="board.readonly"
                class="w-full flex-1"
              >
                <vs-select-item text="근로자대표" value="근로자대표" />
                <vs-select-item
                  text="명예산업안전감독관"
                  value="명예산업안전감독관"
                />
                <vs-select-item text="근로자위원" value="근로자위원" />
                <vs-select-item text="기타" value="기타" />
              </vs-select>
            </vs-td>
            <vs-td class="w-2/12 text-center align-top">
              <div v-if="isPrint" class="print-input"> {{ tr.cell3 }}</div>
              <ml-input v-else
                :readonly="board.readonly"
                v-model="tr.cell3"
                class="w-full flex-1"
                @click.stop
              />
            </vs-td>
            <vs-td class="w-2/12 text-center align-top">
              <sign-field v-model="tr.cell4" :readonly="board.readonly"/>
            </vs-td>
            <vs-td class="w-2/12 text-center align-top">
              <div v-if="isPrint" class="print-input"> {{ tr.cell5 }}</div>
              <ml-input v-else
                :readonly="board.readonly"
                v-model="tr.cell5"
                class="w-full flex-1"
                @click.stop
              />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <!-- 점검표 -->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :isNote="true"
      tableHeaderNote="심의결정사항"
      title="점검표"
      table-header-yes="작성"
      table-header-no="미작성"
      table-header-na="N/A"
      :list="form.inspectList"
      @update-list-check="updateListCheck"
    />
    <ul style="border: 1px solid #cdcdcd; border-top: 0" class="py-5 px-4">
      <li>※ 미이행 시 과태료</li>
      <li>
        <span class="px-2">•</span> 사업주 : (1차) 50만원, (2차) 250만원, (3차)
        500만원
      </li>
      <li>
        <span class="px-2">•</span> 근로자 : (1차) 10만원, (2차) 20만원, (3차)
        30만원
      </li>
    </ul>

    <!-- 기타 의결 및 결정사항 -->
    <div class="mt-5">
      <vs-row class="flex justify-between items-center my-4">
        <h5><i class="dot"></i> 기타 의결 및 결정사항</h5>
        <div>
          <vs-button
            class="ml-4"
            color="secondary"
            @click="addTableRow('etcTableList')"
          >
            항목추가
          </vs-button>
          <vs-button
            class="ml-4"
            color="secondary"
            type="border"
            @click="deleteSelectTable('etcTableList')"
          >
            선택삭제
          </vs-button>
        </div>
      </vs-row>
      <vs-table
        multiple
        v-model="etcSelected"
        :data="form.etcTableList"
        class="w-full table"
        noDataText="데이터가 없습니다"
      >
        <template slot="thead">
          <vs-th class="w-3/12" > <div class="w-full text-center">안건</div> </vs-th>
          <vs-th class="w-9/12"> <div class="w-full text-center">내용</div></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
            style="box-shadow: none !important; transform: translateY(0px)"
          >
            <vs-td class="w-3/12 text-center align-top">
              <div v-if="isPrint" class="print-input"> {{ tr.cell1 }}</div>
              <ml-input v-else
                :readonly="board.readonly"
                v-model="tr.cell1"
                class="w-full flex-1"
                @click.stop
              />
            </vs-td>
            <vs-td class="w-9/12 text-center align-top">
              <div v-if="isPrint" class="print-textarea"> {{ tr.cell2 }}</div>
              <ml-textarea v-else
                :readonly="board.readonly"
                v-model="tr.cell2"
                class="w-full flex-1"
                @click.stop
              />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      section-title="사진대지"
      placeholder="점검 현장 사진"
      :is-print="isPrint"
      :readonly="board.readonly"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import DateSelector from '@/components/selector/DateSelector'
import TableInspect from '@/components/TableInspect'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'
import FileUploadModule from '@/views/modules/FileUploadModule'
import SignField from '@/components/SignField'

export default {
  components: {
    SignField,
    FieldSelectModule,
    DateSelector,
    TableInspect,
    PhotoUploadGridModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]

            if (key === 'userTableList' && 0 < value[key].length) {
              this.userTempId = value[key][value[key].length - 1].id
            }
            if (key === 'workerTableList' && 0 < value[key].length) this.workerTempId = value[key][value[key].length - 1].id
          }
        }
        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {

        value.summary = {
          산업안전보건위원회_사업장명: [],
          산업안전보건위원회_구분: []
        }

        value.summary['산업안전보건위원회_사업장명'].push({
          [this.form.stdInfo.field_name]: 1
        })

        value.summary['산업안전보건위원회_구분'].push({
          [this.form.inputA_1]: 1
        })

        this.$emit('input', value)
      },
    },
  },
  data () {
    return {
      form: {
        stdInfo: {},
        userTableList: [],
        workerTableList: [],
        etcTableList: [],
        inspectList: [],
        inputA_1: '',
        inputA_2: '',
        inputA_3: '',
        inputA_4: '',
        inputA_5: '',
        photoList: [],
        fileList: [],
      },
      userSelected: [],
      workerSelected: [],
      etcSelected: [],
      userTempId: 0,
      workerTempId: 0,
      etcTempId: 0,
    }
  },
  computed: {
    inspectTable () {
      return [
        {
          id: 1,
          label: '산업재해 예방계획의 수립',
          is_checked: '',
        },
        {
          id: 2,
          label: '안전보건관리규정의 작성·변경',
          is_checked: '',
        },
        {
          id: 3,
          label: '근로자의 안전·보건교육',
          is_checked: '',
        },
        {
          id: 4,
          label: '작업환경의 점검 및 개선',
          is_checked: '',
        },
        {
          id: 5,
          label: '종사자의 건강진단 등 건강관리',
          is_checked: '',
        },
        {
          id: 6,
          label: '산업재해의 원인 조사 및 재발 방지대책 수립',
          is_checked: '',
        },
        {
          id: 7,
          label: '산업재해에 관한 통계의 기록 및 유지',
          is_checked: '',
        },
        {
          id: 8,
          label:
            '유해하거나 위험한 기계·기구와 그 밖의 설비를 도입한 경우 안전·보건조치',
          is_checked: '',
        },
        {
          id: 9,
          label: '근로자 안전보건 유지·증진을 위해 필요한 사항',
          is_checked: '',
        },
      ]
    },
    projectId () {
      return parseInt(this.$route.params.proj_id)
    },
    is내부종사자 () {
      return `${this.projectId}` === '2'
    },
    fieldName () {
      return '사업장명'
    }
  },
  methods: {
    addTableRow (type) {

      if (type === 'userTableList' || type === 'workerTableList') {
        this.form[type].push({
          id: type === 'userTableList' ? ++this.userTempId : ++this.workerTempId,
          cell1: '',
          cell2: '',
          cell3: '',
          cell4: '',
          cell5: '',
        })
      }

      if (type === 'etcTableList') {
        this.form[type].push({
          id: ++this.etcTempId,
          cell1: '',
          cell2: '',
        })
      }

    },
    deleteSelectTable (type) {
      if (type === 'userTableList' || type === 'workerTableList') {
        const seletedIds =
          type === 'userTableList'
            ? this.userSelected.map((item) => item.id)
            : this.workerSelected.map((item) => item.id)
        this.form[type] = this.form[type].filter(
          (item) => !seletedIds.includes(item.id)
        )
      }
      if (type === 'etcTableList') {
        const seletedIds = this.etcSelected.map((item) => item.id)
        this.form[type] = this.form[type].filter(
          (item) => !seletedIds.includes(item.id)
        )
      }

    },
    updateListCheck (indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text
    },
  },
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}

.table ::v-deep {
  .vs-con-tbody {
    background: none !important;
    border: 0 !important;
  }
  thead tr {
    background: #f9f9f9 !important;
    border-top: solid 1px #cdcdcd;
    border-bottom: solid 1px #cdcdcd;
  }
  tr {
    background: #fff !important;
    border-bottom: solid 1px #cdcdcd;
  }
}
</style>
